import { render, staticRenderFns } from "./DentalAppointmentPendingTable.vue?vue&type=template&id=2fd6ad80&"
import script from "./DentalAppointmentPendingTable.vue?vue&type=script&lang=js&"
export * from "./DentalAppointmentPendingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports